import Input from "../../../../components/form/Input";
import Select from "../../../../components/form/Select";
import Button from "../../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../../components/ui/Card";
import Label from "../../../../components/ui/Label";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { formatDate } from "../../../../utils/helper";
import { useEffect, useState } from "react";
import { addAssetAdvertisements, getAssetAdvByID, getAssetByID } from "../../../../services/vizyBilityServices";
import { toast } from "react-toastify";
import SelectAdvertisementImage from "./selectAdvertisementImage";
const AdvertisementsModel = ({
  modalStatus,
  setModalStatus,
  AssetId,
  assetData,
  advertisementValue,
  setAdvertisementsValue,
  images,
  setImages,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [addAddLoader, setAddAddLoader] = useState(false);

  const [selectImageAdvertisementModel, setSelectImageAdvertisementModel] = useState(false);
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const azurePhoneDigits = String(azureUserInfo?.Phone || "").replace(/\D/g, "");
  const azurePhone =
    azurePhoneDigits.length === 11 && azurePhoneDigits.startsWith("1")
      ? azurePhoneDigits.slice(1)
      : azurePhoneDigits;

  useEffect(() => {
    if (AssetId) {
      getAssetInfoById(AssetId);
    } else {
      formik.setValues({ ...advertisementValue });
    }
    console.log("assetData", assetData)
  }, []);

  const populateFromAssetData = (assetDataParam) => {
    console.log("Auto-populating from asset data (no API call):", assetDataParam);

    // Calculate end date (30 days from now - 1 month)
    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 30);

    // Auto-populate form with asset data
    formik.setValues({
      AssetAdvertisementId: null, // New advertisement
      AdvertisedPrice: assetDataParam?.Price || "",
      AdvertisedCurrency: assetDataParam?.AdvertisedCurrency || "USD",
      AdDescription: assetDataParam?.AssetDescription || "",
      ContactName: azureUserInfo?.givenName || "",
      ContactEmail: azureUserInfo?.identities?.find((item) => item.signInType === "emailAddress")?.issuerAssignedId || "",
      ContactPhone: azurePhone || "",
      AdStartDate: formatDate(startDate),
      AdEndDate: formatDate(endDate),
      SortOrder: 1,
      Featured: false,
      Enabled: true,
      AdvertiserIds: [1],
    });
    setIsLoading(false);
  };

  const fetchAssetDataAndPopulate = (AssetId, header) => {
    // Only called if assetData not provided from parent
    const payload = `assetId=${AssetId}`;
    getAssetByID(payload, header)
      .then((res) => {
        populateFromAssetData(res?.data);
      })
      .catch((err) => {
        console.error("Error fetching asset data:", err);
        setIsLoading(false);
      });
  };

  const getAssetInfoById = (AssetId) => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `assetId=${AssetId}`;

    // Try to get existing advertisement first
    getAssetAdvByID(payload, header)
      .then((res) => {
        const AdvData = res?.data?.[0];
        console.log("AdvData", AdvData);

        if (AdvData && AdvData.AssetAdvertisementId) {
          // Advertisement exists - use advertisement data
          console.log("Loading existing advertisement data");
          formik.setValues({
            ...AdvData,
            AssetAdvertisementId: AdvData?.AssetAdvertisementId,
            AdvertisedPrice: AdvData?.AdvertisedPrice,
            AdvertisedCurrency: AdvData?.AdvertisedCurrency,
            AdDescription: AdvData?.AdDescription,
            ContactName: AdvData?.ContactName,
            ContactEmail: AdvData?.ContactEmail,
            ContactPhone: AdvData?.ContactPhone,
            AdStartDate: AdvData?.AdStartDate?.split("T")?.[0],
            AdEndDate: AdvData?.AdEndDate?.split("T")?.[0],
            SortOrder: AdvData?.SortOrder,
            Featured: AdvData?.Featured,
            Enabled: AdvData?.Enabled,
            AdvertiserIds: [AdvData?.AdvertiserId],
          });
          setIsLoading(false);
        } else {
          // No advertisement - use asset data from parent if available
          console.log("No advertisement found");
          if (assetData) {
            // Use data from parent (OPTIMIZED - no API call!)
            console.log("Using asset data from parent (no API call needed)");
            populateFromAssetData(assetData);
          } else {
            // Fallback: fetch asset data
            console.log("Asset data not provided, fetching...");
            fetchAssetDataAndPopulate(AssetId, header);
          }
        }
      })
      .catch((err) => {
        // Error - use asset data from parent if available
        console.log("Error getting advertisement");
        if (assetData) {
          console.log("Using asset data from parent (no API call needed)");
          populateFromAssetData(assetData);
        } else {
          console.log("Asset data not provided, fetching...");
          fetchAssetDataAndPopulate(AssetId, header);
        }
      });
  };

  const formik = useFormik({
    initialValues: {
      AssetAdvertisementId: null,
      AdvertisedPrice: "",
      AdvertisedCurrency: "USD",
      AdDescription: "",
      ContactName: azureUserInfo?.givenName || "",
      ContactEmail:
        azureUserInfo?.identities?.find((item) => item.signInType === "emailAddress")?.issuerAssignedId || "",
      ContactPhone: azurePhone || "",
      AdStartDate: formatDate(new Date()),
      AdEndDate: formatDate(new Date()),
      SortOrder: 1,
      Featured: false,
      Enabled: true,
      AdvertiserIds: [1],
    },
    validationSchema: Yup.object({
      SortOrder: Yup.number().required("Sort Order is required").integer("Must be an integer"),
    }),
    onSubmit: (values) => {
      if (AssetId) {
        handleAddAdvertisements(values);
      } else {
        setAdvertisementsValue(values);
        setModalStatus(false);
      }
    },
  });

  const handleAddAdvertisements = async (values) => {
    setAddAddLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = { ...values, AssetId: AssetId };
    addAssetAdvertisements(payload, header)
      .then((res) => {
        toast.success("Advertisements Updated Successfully");
        setAddAddLoader(false);
        setModalStatus(false);
      })
      .catch((err) => {
        setAddAddLoader(false);
        toast.error("Something went wrong.");
      });
  };

  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"lg"}
      >
        <ModalHeader>Advertisements</ModalHeader>
        <ModalBody>
          {isLoading || addAddLoader ? (
            <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0  right-0">
              <span class="loader"></span>
            </div>
          ) : null}
          <Card>
            <CardHeader>
              <CardHeaderChild>
                <CardTitle>Advertisements Info</CardTitle>
              </CardHeaderChild>
            </CardHeader>
            <CardBody>
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Advertised Price</Label>
                  <Input
                    type="number"
                    name="AdvertisedPrice"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.AdvertisedPrice}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Advertised Currency</Label>
                  <div className="flex items-center">
                    <Select
                      name="AdvertisedCurrency"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.AdvertisedCurrency}
                      placeholder="Select Advertised Currency"
                    >
                      <option
                        value=""
                        className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                      >
                        Select Advertised Currency
                      </option>
                      <option
                        class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                        value={"CAD"}
                      >
                        CAD
                      </option>
                      <option
                        class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                        value={"USD"}
                      >
                        USD
                      </option>
                    </Select>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Start Date</Label>
                  <Input
                    type="date"
                    name="AdStartDate"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.AdStartDate}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">End Date</Label>
                  <Input
                    type="date"
                    name="AdEndDate"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.AdEndDate}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Contact Name</Label>
                  <Input
                    type="text"
                    name="ContactName"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ContactName}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Contact Email</Label>
                  <Input
                    type="text"
                    name="ContactEmail"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ContactEmail}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Contact Phone</Label>
                  <Input
                    type="number"
                    name="ContactPhone"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ContactPhone}
                    placeholder="Enter here"
                  />
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <Label htmlFor="id">Sort Order</Label>
                  <Input
                    type="Number"
                    name="SortOrder"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.SortOrder}
                    placeholder="Enter here"
                  />
                  {formik.touched.SortOrder && formik.errors.SortOrder ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.SortOrder}</p>
                  ) : null}
                </div>
                <div className="col-span-12 lg:col-span-2 flex items-center">
                  <input
                    type="checkbox"
                    className="mr-2  text-[#161412]"
                    name="Featured"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.Featured}
                  />
                  <Label htmlFor="id" className="!mb-0">
                    Featured
                  </Label>
                </div>
                <div className="col-span-12 lg:col-span-2 flex items-center">
                  <input
                    type="checkbox"
                    className="mr-2  text-[#161412]"
                    name="Enabled"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.Enabled}
                  />
                  <Label htmlFor="id" className="!mb-0">
                    Enabled
                  </Label>
                </div>

              </div>
            </CardBody>
          </Card>
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild>
            <Button
              onClick={() => setSelectImageAdvertisementModel(true)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#008000]"
            >
              Select Picture ({images?.filter((item) => item.AddedToAdvertisement).length || 0})
            </Button>
          </ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={() => setModalStatus(false)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
            >
              Close
            </Button>
            <Button
              onClick={() => formik.submitForm()}
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
            >
              Save
            </Button>
          </ModalFooterChild>
        </ModalFooter>
        {selectImageAdvertisementModel && (
          <SelectAdvertisementImage
            modalStatus={selectImageAdvertisementModel}
            setModalStatus={setSelectImageAdvertisementModel}
            AssetId={AssetId}
            images={images}
            setImages={setImages}
          />
        )}
      </Modal>
    </>
  );
};
export default AdvertisementsModel;
